import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { contactDetails, officeHours } from "@/mocks/contactData";

export default function ContactInfo() {
  return (
    <section id="contact-info" className="bg-tie-cream py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Contact Details
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                How to Reach Us
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary max-w-2xl mx-auto">
                Our team is based in Dhaka and works with partners across Bangladesh and internationally.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-14">
            {contactDetails.map((detail, i) => (
              <ScrollReveal key={detail.title} delay={i * 100}>
                <div className="bg-white rounded-xl p-6 md:p-7 border border-tie-grey h-full">
                  <div className="w-12 h-12 rounded-lg bg-tie-navy/5 flex items-center justify-center mb-4">
                    <div className="w-6 h-6 flex items-center justify-center text-tie-teal">
                      <i className={detail.icon} />
                    </div>
                  </div>
                  <h3 className="text-base font-semibold text-tie-text-primary mb-2">
                    {detail.title}
                  </h3>
                  <div className="space-y-1">
                    {detail.lines.map((line) => (
                      <p key={line} className="text-sm text-tie-text-secondary leading-relaxed">
                        {line}
                      </p>
                    ))}
                  </div>
                  {detail.note && (
                    <p className="mt-2 text-xs text-tie-text-muted">{detail.note}</p>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={200}>
            <div className="bg-tie-navy rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center text-tie-teal-light">
                    <i className="ri-time-line" />
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-white mb-1">Office Hours</h3>
                  <p className="text-sm text-white/70">{officeHours.weekdays}</p>
                  <p className="text-sm text-white/70">{officeHours.friday}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-tie-teal/20">
                <div className="w-2 h-2 rounded-full bg-tie-teal-light animate-pulse" />
                <span className="text-xs font-medium text-tie-teal-light">{officeHours.support}</span>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}